import { render, staticRenderFns } from "./tab-content.vue?vue&type=template&id=2b5d626c&"
import script from "./tab-content.vue?vue&type=script&lang=js&"
export * from "./tab-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports